import { isNil } from 'lodash/fp';
import { type OperationVariables, type TypedDocumentNode } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

import uniqueContentWithDraftPrecedence, {
  type DeclaresIdKey,
} from '../../../../cms/utils/unique-content-with-draft-precedence';

type ItemWithId = {
  id?: string | null;
  _id?: string | null;
};

type OfferQueryData<TItem extends ItemWithId> = { allOffer: DeclaresIdKey<TItem>[] };

const useOfferQuery = <TItem extends ItemWithId, TVariables extends OperationVariables = OperationVariables>(
  gqlQuery: TypedDocumentNode<OfferQueryData<TItem>, TVariables>,
  ...options: {} extends TVariables
    ? [options?: useQuery.Options<OfferQueryData<TItem>, TVariables>]
    : [options: useQuery.Options<OfferQueryData<TItem>, TVariables>]
) => {
  const response = useQuery<OfferQueryData<TItem>, TVariables>(gqlQuery, ...options);
  const { data } = response;
  return {
    ...response,
    data: isNil(data) ? data : { allOffer: uniqueContentWithDraftPrecedence(response.data?.allOffer) },
  };
};

export default useOfferQuery;
